module.exports = __webpack_public_path__ + "fonts/TelefonicaIconsTracking.d6720f74.ttf";